import React, { useEffect, useState } from 'react';
import { MapPin, X } from 'lucide-react';
const buyers = [{
  name: 'Jessica M.',
  city: 'Miami, FL',
  time: '2 min ago'
}, {
  name: 'Ashley R.',
  city: 'Houston, TX',
  time: '4 min ago'
}, {
  name: 'Diana L.',
  city: 'Los Angeles, CA',
  time: '1 min ago'
}, {
  name: 'Samantha K.',
  city: 'Chicago, IL',
  time: '6 min ago'
}, {
  name: 'Maria G.',
  city: 'San Antonio, TX',
  time: '3 min ago'
}, {
  name: 'Jennifer P.',
  city: 'Phoenix, AZ',
  time: '7 min ago'
}, {
  name: 'Stephanie C.',
  city: 'Dallas, TX',
  time: '5 min ago'
}, {
  name: 'Nicole H.',
  city: 'San Diego, CA',
  time: '9 min ago'
}, {
  name: 'Amanda W.',
  city: 'Orlando, FL',
  time: '2 min ago'
}, {
  name: 'Melissa T.',
  city: 'Las Vegas, NV',
  time: '8 min ago'
}, {
  name: 'Rachel B.',
  city: 'Austin, TX',
  time: '11 min ago'
}, {
  name: 'Lauren S.',
  city: 'New York, NY',
  time: '3 min ago'
}, {
  name: 'Brittany N.',
  city: 'Charlotte, NC',
  time: '14 min ago'
}, {
  name: 'Vanessa O.',
  city: 'Denver, CO',
  time: '6 min ago'
}, {
  name: 'Cristina F.',
  city: 'Tampa, FL',
  time: '10 min ago'
}, {
  name: 'Alicia M.',
  city: 'Atlanta, GA',
  time: '4 min ago'
}, {
  name: 'Priya D.',
  city: 'Seattle, WA',
  time: '12 min ago'
}, {
  name: 'Karen V.',
  city: 'San Jose, CA',
  time: '7 min ago'
}, {
  name: 'Monica R.',
  city: 'El Paso, TX',
  time: '15 min ago'
}, {
  name: 'Sandra L.',
  city: 'Portland, OR',
  time: '5 min ago'
}];
export function PurchasePopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    // Show first popup after 3 seconds
    const initialDelay = setTimeout(() => {
      setVisible(true);
    }, 3000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Auto-hide after 4 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 4000);
    return () => clearTimeout(hideTimer);
  }, [visible, currentIndex]);
  useEffect(() => {
    if (visible || dismissed) return;
    // Show next popup 5 seconds after hiding
    const nextTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % buyers.length);
      setVisible(true);
    }, 5000);
    return () => clearTimeout(nextTimer);
  }, [visible, dismissed]);
  if (dismissed) return null;
  const buyer = buyers[currentIndex];
  return <div style={{
    position: 'fixed',
    bottom: '24px',
    left: '16px',
    zIndex: 9999,
    maxWidth: '290px',
    width: 'calc(100vw - 32px)',
    transition: 'transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.35s ease',
    transform: visible ? 'translateY(0)' : 'translateY(110%)',
    opacity: visible ? 1 : 0,
    pointerEvents: visible ? 'auto' : 'none'
  }} data-id="element-137">
      <div style={{
      background: '#fff',
      borderRadius: '16px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.22), 0 2px 8px rgba(0,0,0,0.10)',
      padding: '12px 14px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      border: '1px solid #f0f0f0'
    }} data-id="element-138">
        {/* Book thumbnail */}
        <div style={{
        flexShrink: 0,
        width: '48px',
        height: '58px',
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0,0,0,0.18)'
      }} data-id="element-139">
          <img src="https://cdn.magicpatterns.com/uploads/5x64F5Z13ZC1A3NMuKuQRb/ebookcoverpacksm.jpg" alt="Feline Harmony Blueprint" style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }} data-id="element-140" />
        </div>

        {/* Info */}
        <div style={{
        flex: 1,
        minWidth: 0
      }} data-id="element-141">
          <p style={{
          margin: 0,
          fontSize: '13px',
          lineHeight: '1.3',
          color: '#111'
        }} data-id="element-142">
            <strong data-id="element-143">{buyer.name}</strong>{' '}
            <span style={{
            fontWeight: 400,
            color: '#444'
          }} data-id="element-144">
              purchased
            </span>
          </p>
          <p style={{
          margin: '3px 0 4px',
          fontSize: '12px',
          fontWeight: 600,
          color: '#e91e8c',
          lineHeight: '1.2'
        }} data-id="element-145">
            Complete Package — $6.39
          </p>
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '3px'
        }} data-id="element-146">
            <MapPin size={11} color="#999" style={{
            flexShrink: 0
          }} data-id="element-147" />
            <span style={{
            fontSize: '11px',
            color: '#999',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }} data-id="element-148">
              {buyer.city} · {buyer.time}
            </span>
          </div>
        </div>

        {/* Right side: close + checkmark */}
        <div style={{
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '6px'
      }} data-id="element-149">
          <button onClick={() => setDismissed(true)} style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '2px',
          color: '#ccc',
          lineHeight: 1
        }} aria-label="Close" data-id="element-150">
            <X size={12} data-id="element-151" />
          </button>
          <div style={{
          width: '24px',
          height: '24px',
          borderRadius: '50%',
          background: '#22c55e',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }} data-id="element-152">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-153">
              <polyline points="20 6 9 17 4 12" data-id="element-154" />
            </svg>
          </div>
        </div>
      </div>
    </div>;
}